<div class="app-footer-container">
  <div class="version-banner" fxLayout="row">
  <div fxFlex="" class="version-banner__font">Version: {{buildVersion}} - {{browserInfo.name}}: {{browserInfo.version}}</div>
</div>
</div>
